import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@client';
import { SupplierResponse } from '@module/supplier/model/SupplierResponse';
import { SupplierDetailsForm } from '@module/supplier/model/SupplierDetailsForm';

export const supplierMainDetailsApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ['supplierMainDetails'],
  reducerPath: 'supplier-main-details-api',
  endpoints: (build) => ({
    loadMainDetails: build.query<SupplierResponse, { supplierId: string }>({
      query: ({ supplierId }) => ({
        url: `/secured/supplier/${supplierId}/load`,
        method: 'GET'
      }),
      providesTags: (res, _error, { supplierId }) =>
        res
          ? [{ type: 'supplierMainDetails', id: supplierId }]
          : ['supplierMainDetails']
    }),
    saveMainDetails: build.mutation<
      SupplierResponse,
      { supplierId: string; formData: SupplierDetailsForm }
    >({
      query: (data) => ({
        url: '/secured/supplier/save-details',
        method: 'POST',
        data: data.formData
      }),
      invalidatesTags: (res, _error, { supplierId }) =>
        res
          ? [{ type: 'supplierMainDetails', id: supplierId }]
          : ['supplierMainDetails']
    })
  })
});

export const { useLoadMainDetailsQuery, useSaveMainDetailsMutation } =
  supplierMainDetailsApi;
